import { MatchGroup } from "types/entities/Match";

export const getSelectedGroups = (groups: MatchGroup[], selectedGroupIds: number[]): MatchGroup[] =>
  groups.filter((group) => selectedGroupIds.includes(group.group_id));
